{
  "version": 1,
  "asset_id": "0fa2effc-c2eb-4557-8558-a65bf4732277",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0fa2effc-c2eb-4557-8558-a65bf4732277/loc-cedar-park-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0fa2effc-c2eb-4557-8558-a65bf4732277/loc-cedar-park-1280.avif",
  "original_filename": "loc-cedar-park-1280.avif",
  "size": 100630,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:20Z"
}
